import { Component, OnDestroy, OnInit } from '@angular/core';

import { untilDestroyed, UrlParamsService } from '@app/core';
import { User } from '@app/models';
import { AppService, UserService } from '@app/services';

@Component({
  selector: 'app-menu-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss'],
  standalone: false
})
export class ConfigurationComponent implements OnInit, OnDestroy {
  currentUser: User;

  constructor(
    public appService: AppService,
    public urlParamsService: UrlParamsService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.userService
      .watchCurrentUser()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: user => (this.currentUser = user)
      });
  }

  ngOnDestroy() {}

  canShowOAuthClientsMenu() {
    return this.currentUser?.settings?.developer && this.currentUser?.currentPermissions?.actions_applications_oz;
  }
}
